@let installmentsSliced =
  maxInstallments() > 0 ? installments().slice(0, maxInstallments()) : installments();

<header class="d-flex justify-content-between align-items-center my-3 px-4">
  <div></div>
  <p class="text-center text-secondary">Detalhes da parcela</p>
  <i (click)="handleCloseDrawer()" class="bi bi-x-lg"></i>
</header>
<div class="width-20vw">
  <div class="modal-number-installments">
    <div class="modal-installments">
      <div>
        @for (installment of installmentsSliced; let i = $index; track i) {
          <div class="modal-installment-card align-items-center" (click)="onSelect(installment)">
            <div class="modal-installment-card-text">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <p class="installments-value-text">
                    {{ installment.installment }}
                    {{ installment.installment === 1 ? 'parcela' : 'parcelas' }}
                    de
                    <strong>{{ installment.value | currency }}</strong>
                  </p>
                  @if (hasCreditFee()) {
                    <small
                      >Total a pagar:
                      {{ installment.installment * installment.value | currency }}
                    </small>
                  }
                  <div>
                    @if (installment.recommendationWhenChoosingAnInstallment) {
                      <p style="font-size: 0.75rem; color: #217a65">
                        Pague com mais tempo e equilíbrio.
                      </p>
                    }
                  </div>
                </div>
                @if (installment.recommendationWhenChoosingAnInstallment) {
                  <div class="ms-5 recommendationWhenChoosingAnInstallment">Recomendado</div>
                }
                @if (enableRecommendationWhenStarting() && installment.recommendationWhenStarting) {
                  <div class="recommendationWhenChoosingAnInstallment">Cabe no bolso</div>
                }
              </div>
            </div>
            <div class="modal-installment-card--check">
              <i class="bi bi-chevron-right"></i>
            </div>
          </div>
        }
        <footer class="sticky-bottom bg-white p-3">
          <div class="d-flex">
            <div class="flex-1">
              <p class="text-secondary fs-14">Valor a pagar</p>
              <p>
                {{ selectedInstallment()?.installment }}x de
                <span class="fw-bold">{{ selectedInstallment()?.value | currency }}</span>
              </p>
            </div>
            @if (showInstallmentCost()) {
              <app-fee-details-button caller="modal"></app-fee-details-button>
            }
          </div>
        </footer>
      </div>
    </div>
  </div>
</div>
